<template>
    <div class="menu001">
      <ul class="first-tab dib-vam-fz0">
        <li v-for="(item,index) in firstTabList" :class="{active:index==firstTabChoosed}" @click="firstTabFn(index)">
          <p>{{item.text}}</p></li>
      </ul>
    </div>
</template>

<script>
  export default {
    name: "menu001",
    data() {
      return {
        firstTabList: [
          {text: '查询', path: "/fastquery"},
          {text: '我的', path: "/my"},
          {text: '分类', path: "/classfy0"},
          {text: '常见问题', path: "/question0"},
        ],
        firstTabChoosed: 0,
      }
    },
    components: {},
    created() {

    },
    mounted() {

    },
    methods: {
      firstTabFn(index) {
        this.firstTabChoosed = index;
        this.$router.push(this.firstTabList[index].path)
      },
    },
    computed: {},
  }
</script>

<style scoped lang="scss">
    .menu001{
      .first-tab {
        font-size: 0;
        background: #ffffff;
        border: 1px solid #cccccc;
        position: fixed;
        bottom: 0;
        width: 100%;
        li {
          width: 25%;
          line-height: 88-5-16*2px;
          border-bottom: 5px solid transparent;
          font-size: 24px;
          padding-top: 16px;
          padding-bottom: 16px;
          height: 88-5px;
          p {
            border-left: 1px solid #c8c6c6;
          }
          &.active {
            border-bottom: 5px solid #fa4f68;
          }
        }
        li + li {
          /*border-left: 1px solid #c8c6c6;*/
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/menu/menu001.vue